import { Injectable } from '@angular/core';
import { DownloadFileInterface } from '@app/core/interfaces/download-file.interface';
import { RequestService } from '@app/core/request/request.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PolicyDetailsService {
    constructor(
        private request: RequestService,
    ) {}

    public downloadPolicy(history_indication: string): Observable<DownloadFileInterface> {
        const payload = {
            toon_historie_indicatie: history_indication,
        };

        return this.request.download('relatie-algemeen/verstrekken/polis', payload);
    }
}
